<template>
  <v-layout
    row
    wrap
    class="ma-0"
  >
    <v-flex xs12>
      <div>
        {{ address.given_name }} {{ address.family_name }}
      </div>
      <div v-if="address.organization">
        {{ address.organization }}
      </div>
      <div>
        {{ address.address_line1 }}
      </div>
      <div class="text-no-wrap">
        {{ address.locality }}, {{ address.administrative_area }}
      </div>
      <div>
        {{ address.postal_code }}
      </div>
      <div>
        {{ countryName }}
      </div>
      <div v-if="address.telephone">
        {{ address.telephone | telephone }}
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderAddressShort',

  props: {
    address: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['countries']),

    countryName () {
      const country = this.countries.find(item => item.code === this.address.country_code)

      return country ? country.name : this.address.country_code
    }
  }
}
</script>
